'use client';

import { Icon, Text } from '@stone-payments/jade';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSessionStatus } from '../../hooks/useSessionStatus';

type PageRefreshTimerProps = {
  minutesToRefresh: number;
  sessionId: string;
};

export function PageRefreshTimer({
  minutesToRefresh,
  sessionId,
}: PageRefreshTimerProps) {
  const { formatMessage } = useIntl();
  const intervalMs = minutesToRefresh * 60 * 1000;
  const { dataUpdatedAt } = useSessionStatus(sessionId, intervalMs);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 1000);

    return () => clearInterval(interval);
  }, []);

  const elapsedMs = dataUpdatedAt ? now - dataUpdatedAt : 0;
  const secondsRemaining = Math.min(
    minutesToRefresh * 60,
    Math.max(0, Math.ceil((intervalMs - elapsedMs) / 1000))
  );
  const minutes = Math.floor(secondsRemaining / 60);
  const seconds = secondsRemaining % 60;
  const formattedTime = `${minutes}min ${seconds.toString().padStart(2, '0')}s`;

  return (
    <div className="flex justify-center gap-jade-100">
      <Icon color="medium" size="small" use="action-refresh" />
      <Text variant="text-medium">
        {formatMessage({ id: 'pageRefreshTimer.message' })}{' '}
        <span className="text-jade-content-brand-secondary font-semibold">
          {formattedTime}
        </span>
      </Text>
    </div>
  );
}
